import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { BaseFunnelAnswers } from '../types';

export type FunnelState<A extends Partial<BaseFunnelAnswers> = Partial<BaseFunnelAnswers>> = A & {
  clearAnswers: () => void;
  setAnswers: (answers: A) => void;
};

/**
 * Holds the local funnel state and additional actions:
 *
 * - clearAnswers: Clears all answers
 * - setAnswers: Set answers, overwrite if they already exist
 */
export const useFunnelState = create<FunnelState>()(
  persist(
    set => ({
      clearAnswers: () => set(state => ({ clearAnswers: state.clearAnswers, setAnswers: state.setAnswers }), true),
      setAnswers: answers => set({ ...answers }),
    }),
    { name: 'funnel-state', storage: createJSONStorage(() => sessionStorage) },
  ),
);
